export const conversionFactors = {
  cm: 1,
  mm: 0.1,
  in: 2.54,
  inch: 2.54,
};

const normalizeUnit = (unit) => {
  const normalizedUnit = String(unit || "").toLowerCase();

  if (
    normalizedUnit === "1" ||
    normalizedUnit === "in" ||
    normalizedUnit === "inch" ||
    normalizedUnit === "inches"
  ) {
    return "inch";
  }

  if (
    normalizedUnit === "2" ||
    normalizedUnit === "mm" ||
    normalizedUnit === "millimeter" ||
    normalizedUnit === "millimeters"
  ) {
    return "mm";
  }

  if (
    normalizedUnit === "3" ||
    normalizedUnit === "cm" ||
    normalizedUnit === "centimeter" ||
    normalizedUnit === "centimeters"
  ) {
    return "cm";
  }

  return "mm";
};

const getConversionFactor = (fromUnit, toUnit) => {
  const normalizedFromUnit = normalizeUnit(fromUnit);
  const normalizedToUnit = normalizeUnit(toUnit);

  if (normalizedFromUnit === normalizedToUnit) {
    return 1;
  }

  return (
    conversionFactors[normalizedFromUnit] /
    conversionFactors[normalizedToUnit]
  );
};

const convertCoordinateArray = (coordinates, factor) => {
  if (!Array.isArray(coordinates)) {
    return coordinates;
  }

  const isNumericCoordinate = coordinates.every(
    (coordinate) => typeof coordinate === "number"
  );

  if (isNumericCoordinate) {
    return coordinates.map((coordinate) => coordinate * factor);
  }

  return coordinates.map((coordinate) =>
    convertCoordinateArray(coordinate, factor)
  );
};

const convertCoordinateObject = (coordinateObject, factor) => {
  const convertedObject = { ...coordinateObject };

  if (typeof convertedObject.x === "number") {
    convertedObject.x *= factor;
  }

  if (typeof convertedObject.y === "number") {
    convertedObject.y *= factor;
  }

  if (typeof convertedObject.z === "number") {
    convertedObject.z *= factor;
  }

  return convertedObject;
};

export const convertCoordinates = (sourcePoints, fromUnit, toUnit) => {
  const factor = getConversionFactor(fromUnit, toUnit);

  if (factor === 1) {
    return sourcePoints;
  }

  if (
    sourcePoints !== null &&
    typeof sourcePoints === "object" &&
    !Array.isArray(sourcePoints)
  ) {
    return convertCoordinateObject(sourcePoints, factor);
  }

  return convertCoordinateArray(sourcePoints, factor);
};